import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: { name: 'main' }
    }, {
      path: '/main',
      name: 'main',
      component: (resolve) => {
        require(['../pages/main/main.vue'], resolve)
      }
    }, {
      path: '/deviceAlert',
      name: 'deviceAlert',
      component: (resolve) => {
        require(['../pages/main/deviceAlert.vue'], resolve)
      }
    }, {
      path: '/forget',
      name: 'forget',
      component: (resolve) => {
        require(['../pages/main/forget.vue'], resolve)
      }
    }, {
      path: '/reset',
      name: 'reset',
      component: (resolve) => {
        require(['../pages/main/reset.vue'], resolve)
      }
    }, {
      path: '/register',
      name: 'register',
      component: (resolve) => {
        require(['../pages/main/register.vue'], resolve)
      }
    }, {
      path: '/active',
      name: 'active',
      component: (resolve) => {
        require(['../pages/main/active.vue'], resolve)
      }
    }, {
      path: '/datasetAccess/:id',
      name: 'datasetAccess',
      component: (resolve) => {
        require(['../pages/main/datasetAccess.vue'], resolve)
      }
    }, {
      path: '/coverageRate',
      name: 'coverageRate',
      component: (resolve) => {
        require(['../pages/main/coverageRate.vue'], resolve)
      }
    }, {
      path: '/genePanel',
      name: 'genePanel',
      component: (resolve) => {
        require(['../pages/main/genePanel.vue'], resolve)
      }
    }, {
      path: '/phenotypeDisease',
      name: 'phenotypeDisease',
      component: (resolve) => {
        require(['../pages/main/phenotypeDisease.vue'], resolve)
      }
    }, {
      path: '/user',
      name: 'user',
      component: (resolve) => {
        require(['../pages/main/user.vue'], resolve)
      }
    }, {
      path: '/panel',
      name: 'panel',
      component: (resolve) => {
        require(['../pages/main/panel.vue'], resolve)
      }
    }, {
      path: '/config',
      name: 'config',
      component: (resolve) => {
        require(['../pages/main/config.vue'], resolve)
      }
    }, {
      path: '/point',
      name: 'point',
      component: (resolve) => {
        require(['../pages/main/point.vue'], resolve)
      }
    }, {
      path: '/systemInfo',
      name: 'systemInfo',
      component: (resolve) => {
        require(['../pages/main/systemInfo.vue'], resolve)
      }
    }, {
      path: '/configEdit/:id?',
      name: 'configEdit',
      component: (resolve) => {
        require(['../pages/main/configEdit.vue'], resolve)
      }
    }, {
      path: '/caseList/:tab?',
      name: 'caseList',
      component: (resolve) => {
        require(['../pages/caseList.vue'], resolve)
      }
    }, {
      path: '/caseEdit/:dataset',
      name: 'caseEdit',
      component: (resolve) => {
        require(['../pages/caseEdit.vue'], resolve)
      }
    }, {
      path: '/caseDetail/:type/:id',
      name: 'caseDetail',
      component: (resolve) => {
        require(['../pages/caseDetail.vue'], resolve)
      }
    }, {
      path: '/datasetList',
      name: 'datasetList',
      component: (resolve) => {
        require(['../pages/datasetList.vue'], resolve)
      }
    }, {
      path: '/datasetEdit',
      name: 'datasetEdit',
      component: (resolve) => {
        require(['../pages/datasetEdit.vue'], resolve)
      }
    }, {
      path: '/datasetDetail/:type/:id',
      name: 'datasetDetail',
      component: (resolve) => {
        require(['../pages/datasetDetail.vue'], resolve)
      }
    }, {
      path: '/datasetInvitationConfirm',
      name: 'datasetInvitationConfirm',
      component: (resolve) => {
        require(['../pages/main/datasetInvitationConfirm.vue'], resolve)
      }
    }, {
      path: '/genomeBrowser/:id/:type/:symbol/:vkey',
      name: 'genomeBrowser',
      component: (resolve) => {
        require(['../pages/main/genomeBrowser.vue'], resolve)
      }
    }, {
      path: '*',
      redirect: { name: 'main' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js